<div class="signImageConfig">
  <div id="signImageConfig" #SignImageConfig2>
    <ng-container *ngIf="selectedCert">
      <ng-container *ngTemplateOutlet="ImageConfigView"></ng-container>
    </ng-container>
  </div>
</div>

<form #f="ngForm" (ngSubmit)="f.form.valid && onClickConfirmButton()" appFocusFirstElement class="w-100">
  <h2 mat-dialog-title mat-dialog-draggable-title>{{'digital_certificate_management.select_certificate' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()" cdkFocusInitial>
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>

  <mat-divider></mat-divider>
  <mat-dialog-content class="select-certificate">
    <i>{{getMessageSelectCert()}}</i>

    <div class="row mt-3">
      <div class="col-md-12 pb-3">
        <ng-container *ngIf="certificates== undefined || certificates.length == 0; else hasCertificates">
          {{'digital_certificate_management.not_exist_certificate' | translate}}
        </ng-container>
        <ng-template #hasCertificates>
          <ng-container *ngFor="let item of certificates">
            <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group border-bottom"
                           [(ngModel)]="typeCertificate" [ngModelOptions]="{standalone: true}"
                           *ngIf="(item.type != 0 && item.type != 4) || isHsmPermission">
            <mat-radio-button class="example-radio-button" [value]="item.type" [ngSwitch]="item.type"
                              (change)="onChangeType()">
                              <!-- this.signType === SignDocumentComponent.SIGN_SLOT -->
              <ng-container *ngSwitchCase="1">
                {{'digital_certificate_management.rd_certificate_type.cbx_usb' | translate}}
                <i>({{(signType === "slot") ? getMessageUsbTokenThreshold() : ''}})</i>
              </ng-container>
              <ng-container *ngSwitchCase="2">
                {{'digital_certificate_management.rd_certificate_type.cbx_sim_ca' | translate}}
              </ng-container>
                <ng-container *ngSwitchCase="4">
                {{'digital_certificate_management.rd_certificate_type.cbx_hsm' | translate}}
              </ng-container>
                <ng-container *ngSwitchCase="0">
                {{'digital_certificate_management.rd_certificate_type.cbx_server' | translate}}
                </ng-container>
              <ng-container *ngSwitchCase="3">
                {{'digital_certificate_management.rd_certificate_type.cbx_otp' | translate}}
              </ng-container>

              <ng-container *ngSwitchCase="signTypes.CLOUD_CA">
                {{'enterprise-certificate_management.cbx_certificate_type.cbx_CLOUD_CA' | translate}}
                <i>({{getMessageCloudCaThreshold()}})</i>
              </ng-container>

            </mat-radio-button>
            <div class="container" *ngIf="item.type == typeCertificate">
              <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                          (ngModelChange)="setIssueTo($event);selectCertificate($event);"     [(ngModel)]="selectedCert" [ngModelOptions]="{standalone: true}">
                <!-- Not OTP -->
                <mat-table [dataSource]="item.listCert" *ngIf="item.type != 3; else otp">
                  <!-- Chủ thể CTS column -->
                  <ng-container matColumnDef="issuedTo">
                    <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                     style="max-width: 50%;">
                      {{'digital_certificate_management.issuedTo_name' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let cert" class="mat-cell-non-boder-right-bottom align-middle"
                              style="max-width: 50%" matTooltip="{{cert.issuedTo}}">
                      <mat-radio-button class="ml-2 mt-2 mat-header-cell-center" [value]="cert">
                      </mat-radio-button>
                      <span class="fix-width">{{cert.issuedTo}}</span>
                    </mat-cell>
                  </ng-container>

                  <!-- Mã số thuế column -->
                  <ng-container matColumnDef="taxCode">
                    <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                     style="max-width: 30%;">
                      {{'digital_certificate_management.mst' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let cert" class="mat-cell-non-boder-right-bottom number-cell-right"
                              style="max-width: 30%;" matTooltip="{{cert.taxCode}}">
                      {{cert.taxCode}}
                    </mat-cell>
                  </ng-container>

                  <!-- Số điện thoại -->
                  <ng-container matColumnDef="phoneNumber">
                    <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                     style="max-width: 30%;"
                                     [ngStyle]="{'display': typeCertificate == 2 ? null : 'none'}">
                      {{'digital_certificate_management.lbl_phone' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let cert" class="mat-cell-non-boder-right-bottom number-cell-right"
                              style="max-width: 30%;" [ngStyle]="{'display': typeCertificate == 2 ? null : 'none'}"
                              matTooltip="{{cert.phoneNumber}}">
                      {{cert.phoneNumber}}
                    </mat-cell>
                  </ng-container>

                  <!-- Ngày hoàn thành column -->
                  <ng-container matColumnDef="expireDate">
                    <mat-header-cell *matHeaderCellDef class="co-col" [ngClass]="item.type != signTypes.CLOUD_CA ? 'mat-cell-non-boder-bottom' : 'mat-cell-non-boder-right-bottom'" style="max-width: 25%;">
                      {{'headertable.end_of_activate_date' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let cert" class="number-cell-right" [ngClass]="item.type != signTypes.CLOUD_CA ? 'mat-cell-non-boder-bottom' : 'mat-cell-non-boder-right-bottom'"
                              style="max-width: 25%;" matTooltip="{{cert.expireDate | dateformat}}">
                      {{cert.expireDate | dateformat}}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="hasTransSaved" *ngIf="item.type == signTypes.CLOUD_CA">
                    <mat-header-cell *matHeaderCellDef style="max-width: 10%;" style="width: 10%"
                      class="co-col mat-cell-non-boder-bottom">
                      {{'enterprise_group_user_management.table_headers.save_session_sign' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let cert" style="max-width: 10%;" style="width: 10%"
                      class="mat-cell-non-boder-bottom number-cell-center word-break-line">
                      <div *ngIf="cert.hasTransSaved == true" [matTooltip]="'button.yes_sign_method_default' | translate" style="color: #09847b">
                        {{ 'button.yes_sign_method_default' | translate }}
                      </div>
                      <div *ngIf="cert.hasTransSaved == false" [matTooltip]="'button.no' | translate" style="color: #da190b">
                        {{ 'button.no' | translate }}
                      </div>
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="item.type == signTypes.CLOUD_CA ? columnsToDisplayCA : columnsToDisplay;"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: item.type == signTypes.CLOUD_CA ? columnsToDisplayCA : columnsToDisplay;"></mat-row>
                </mat-table>

                <!-- OTP -->
                <ng-template #otp>
                  <h6><strong>{{'digital_certificate_management.phone_number' | translate}}</strong></h6>
                  <mat-radio-button class="example-radio-button w-100" *ngFor="let cert of item.listCert"
                                    [value]="cert">
                    <span style="font-size: 16px;">{{cert.phoneNumber}}</span>
                  </mat-radio-button>
                </ng-template>

              </mat-radio-group>
            </div>
          </mat-radio-group>
          </ng-container>
        </ng-template>
      </div>
    </div>
    <ng-container
      *ngIf="selectedCert">
      <div style="border-color: #F2F2F2;"
          class="d-flex justify-content-between align-items-center pb-2 border-bottom mt-2">
          <div class="text-base font-bold">{{
              'enterprise_contract.image_signing.title_step_2'
              | translate }}
          </div>
      </div>

      <div>
          <nz-tabset class="mt-3" [nzTabPosition]="'top'" [nzType]="'card'"
              [(nzSelectedIndex)]="indexSelect"
              (nzSelectChange)="nzSelectChange($event.index)">

              <!-- Tab ảnh mặc định hệ thống -->
              <nz-tab [nzTitle]="'enterprise_contract.image_signing.new_tab.system_image' | translate">
                  <div class="tab-content">
                      <app-image-sign-config-lot [selectedCert]="selectedCert" [isHiddenLabel]="false"
                          [enterpriseName]="enterpriseName" [signConfig]="signConfig"
                          [domRenderImage]="SignImageConfig2" [signMethod]="enumSignMethod"
                          [scopeType]="scopeType"
                          (eventConfirmChangeSignatureImage)="convertHtmlToImage()">
                          <ng-container *ngTemplateOutlet="ImageConfigView">
                          </ng-container>
                      </app-image-sign-config-lot>
                  </div>
              </nz-tab>

              <!-- tab ảnh ký -->
              <nz-tab [nzTitle]="uploadImage">
                  <ng-template #uploadImage>{{
                      "enterprise_contract.image_signing.new_tab.image_signature"
                      | translate
                      }}
                  </ng-template>
                  <div class="tab-content">
                    <div class="row">
                      <div
                        class="clearfix nz-upload-clearfix d-flex justify-content-center">
                        <nz-upload [nzAccept]="'image/jpeg,image/jpg,image/png'"
                          [nzPreview]="handlePreview"
                          class="avatar-uploader px-3 pt-3"
                          [nzCustomRequest]="dummyRequest" nzName="avatar"
                          nzListType="picture-card" [nzShowUploadList]="false"
                          [nzBeforeUpload]="beforeUpload"
                          (nzChange)="handleChange($event)">
                          <ng-container
                              *ngIf="!avatarUrl && !selectedCert.imageUrl">
                              <i class="upload-icon" nz-icon
                                  [nzType]="loading ? 'loading' : 'plus'"></i>
                              <div class="ant-upload-text">
                                  {{ "form.select_upload" | translate }}
                              </div>
                          </ng-container>
                          <img *ngIf="avatarUrl || selectedCert.imageUrl"
                              [src]="sanitize(avatarUrl ? avatarUrl : selectedCert.imageUrl)"
                              style="max-height: 300px; max-width: 600px" />
                        </nz-upload>
                      </div>
                    </div>

                    <ng-container *ngIf="avatarUrl;else noteUploadImage">
                      <div class="d-flex justify-content-center mt-1">
                        <div class="btn-upload-signature">
                          <nz-upload [nzAccept]="'image/jpeg,image/jpg,image/png'"
                            [nzPreview]="handlePreview" class="px-3"
                            [nzCustomRequest]="dummyRequest" nzName="avatar"
                            nzListType="picture-card" [nzShowUploadList]="false"
                            [nzBeforeUpload]="beforeUpload"
                            (nzChange)="handleChange($event)">
                            <svg width="17" height="17" viewBox="0 0 17 17"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M14.15 2.91616C12.7 1.46616 10.71 0.566162 8.50001 0.566162C4.08001 0.566162 0.51001 4.14616 0.51001 8.56616C0.51001 12.9862 4.08001 16.5662 8.50001 16.5662C12.23 16.5662 15.34 14.0162 16.23 10.5662H14.15C13.33 12.8962 11.11 14.5662 8.50001 14.5662C5.19001 14.5662 2.50001 11.8762 2.50001 8.56616C2.50001 5.25616 5.19001 2.56616 8.50001 2.56616C10.16 2.56616 11.64 3.25616 12.72 4.34616L9.50001 7.56616H16.5V0.566162L14.15 2.91616Z"
                                    fill="#EE0033" />
                            </svg>
                            <span class="ml-2"
                                style="color: #EE0033;">{{'button.change_signature_image'
                                | translate}}</span>
                          </nz-upload>
                        </div>
                      </div>
                      <div class="guiding-info d-flex justify-content-center mt-1">
                          {{ 'messages.note_signature_image' | translate }}
                      </div>
                    </ng-container>
                    <ng-template #noteUploadImage>
                        <div class="d-flex justify-content-center text-center">
                            <span class="guiding-info pt-2 pb-3">{{
                                "title.upload_image_sign_guiding1" | translate }}
                                <br />{{
                                "title.upload_image_sign_guiding2" | translate
                                }}</span>
                        </div>
                    </ng-template>
                </div>
              </nz-tab>

              <!-- tab vẽ chữ ký desktop -->
              <nz-tab [nzTitle]="drawSignature" (nzSelect)="onSelectDrawSign()">
                <ng-template #drawSignature>{{
                    "enterprise_contract.image_signing.new_tab.draw_signature"
                    | translate
                    }}
                </ng-template>

                <div class="steps-content">
                    <div class="tab-content d-flex justify-content-center">
                        <app-canvas [canvasWidth]="canvasWidth"
                            [isSignflowDocument]="true" [canvasHeight]="canvasHeight">
                        </app-canvas>
                    </div>
                </div>
              </nz-tab>
          </nz-tabset>
      </div>
    </ng-container>
  </mat-dialog-content>
  <mat-divider class="mt-2"></mat-divider>
  <mat-dialog-actions align="center">
    <button mat-stroked-button color="primary" class="mr-3" (click)="onClickCancelButton()" type="button">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>
    <button mat-raised-button type="submit" [disabled]="!selectedCert || (!fileUpload && indexSelect != 0)" color="primary">
      <mat-icon class="mr-0">gesture</mat-icon>
      {{'button.sign' | translate}}
    </button>
  </mat-dialog-actions>
</form>

<ng-template #ImageConfigView>
  <ng-container *ngIf="!signConfig?.signatureImage.enabled;else haveSignatureImage">
      <div style="padding: 20px;" [style.width]="'1184px'" [style.height]="'528px'"
          class="image-config_view__content align-items-center d-flex flex-row"
           [style.justify-content]="transformContentPositionValue(signConfig.contentPosition.value)">
          <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
      </div>
  </ng-container>
  <ng-template #haveSignatureImage>
      <ng-container [ngSwitch]="signConfig?.signaturePosition?.value">
          <div style="padding: 20px;" *ngSwitchCase="'left'" [style.width]="'1464px'" [style.height]="'528px'"
              class="image-config_view__content d-flex align-items-center justify-content-center flex-row">
              <div class="d-flex justify-content-center align-items-center"
                  [style.flex]="getNumber(signConfig.signatureRatio.value)[0]">
                  <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
              </div>
              <div style="padding-left: 24px;" class="d-flex justify-content-start align-items-center"
                   [style.justify-content]="transformContentPositionValue(signConfig.contentPosition.value)"
                  [style.flex]="getNumber(signConfig.signatureRatio.value)[1]">
                  <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
              </div>
          </div>
          <div style="padding: 20px;" *ngSwitchCase="'right'" [style.width]="'1464px'" [style.height]="'528px'"
              class="image-config_view__content d-flex align-items-center justify-content-center flex-row-reverse">
              <div class="d-flex justify-content-center align-items-center"
                  [style.flex]="getNumber(signConfig.signatureRatio.value)[0]">
                  <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
              </div>
              <div style="padding-left: 24px;" class="d-flex justify-content-start align-items-center"
                   [style.justify-content]="transformContentPositionValue(signConfig.contentPosition.value)"
                  [style.flex]="getNumber(signConfig.signatureRatio.value)[1]">
                  <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
              </div>
          </div>
          <div style="padding: 20px;" *ngSwitchCase="'top'" [style.width]="'1184px'" [style.height]="'932px'"
              class="image-config_view__content d-flex align-items-center justify-content-center flex-column">
              <div class="d-flex justify-content-center align-items-center"
                  [style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 132 * 4 + 'px'">
                  <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
              </div>
              <div class="d-flex justify-content-start align-items-center"
                   [style.justify-content]="transformContentPositionValue(signConfig.contentPosition.value)"
                  [style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 132 * 4 + 'px'">
                  <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
              </div>
          </div>
          <div style="padding: 20px;" *ngSwitchCase="'bottom'" [style.width]="'1184px'" [style.height]="'932px'"
              class="image-config_view__content d-flex align-items-center justify-content-center flex-column-reverse">
              <div class="d-flex justify-content-center align-items-center"
                  [style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 132 * 4 + 'px'">
                  <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
              </div>
              <div class="d-flex justify-content-start align-items-center"
                   [style.justify-content]="transformContentPositionValue(signConfig.contentPosition.value)"
                  [style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 132 * 4 + 'px'">
                  <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
              </div>
          </div>
      </ng-container>
  </ng-template>
</ng-template>

<ng-template #SignatureViewContent>
  <ng-container *ngIf="signConfig.signatureImageBase64.value.split(',')[1]">
      <ng-container
          *ngIf="signConfig?.signaturePosition?.value === 'left' || signConfig?.signaturePosition?.value === 'right'">
          <img [style.max-height]="'508px'"
              [style.max-width]="346 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) + 'px'"
              [src]="signConfig.signatureImageBase64.value">
      </ng-container>
      <ng-container
          *ngIf="signConfig?.signaturePosition?.value === 'top' || signConfig?.signaturePosition?.value === 'bottom'">
          <img [style.max-width]="'1164px'"
              [style.height]="imageSignConfig?.widthImageSignature < 346 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) ? (217 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) + 28) + 'px' : 'auto'"
              [style.max-height]="(217 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) + 28) + 'px'"
              [src]="signConfig.signatureImageBase64.value">
      </ng-container>
  </ng-container>
</ng-template>
<ng-template #ImageViewContent>
  <div id="imageConfigContainer" class="imageConfigContainer">
      <ng-container *ngFor="let key of getConfigKeyList()">
          <ng-container *ngTemplateOutlet="ConfigViewItem; context: {$implicit: key}"></ng-container>
      </ng-container>

      <ng-container *ngIf="signConfig.greenTick.enabled">
          <div class="green-tick w-100"
               [style.justify-content]="transformContentPositionValue(signConfig.contentPosition.value)"
              [style.top]="signConfig.signaturePosition.value ? 18 * 4 * (+getNumber(signConfig.signatureRatio.value)[1] / 100) + 'px' : '72px'"
              >
              <svg width="316" height="232" viewBox="0 0 79 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M77.2308 2.10253C78.9231 3.7948 78.9231 6.53852 77.2308 8.23079L29.5641 55.8975C27.8719 57.5897 25.1281 57.5897 23.4359 55.8975L1.7692 34.2308C0.0769319 32.5385 0.0769319 29.7948 1.7692 28.1025C3.46148 26.4103 6.20519 26.4103 7.89746 28.1025L26.5 46.7051L71.1025 2.10253C72.7948 0.41026 75.5385 0.41026 77.2308 2.10253Z"
                      fill="#52C41A" />
              </svg>
          </div>
      </ng-container>
  </div>
</ng-template>

<ng-template #ConfigViewItem let-data>
  <div [style.font-style]="signConfig.fontStyle.value || ''" [style.font-weight]="signConfig.fontWeight.value || ''"
      [style.fontFamily]="signConfig.fontFamily.value || 'Times-Roman'" *ngIf="showConfig(data)"
      class="view-content-item"
       [style.justify-content]="transformContentPositionValue(signConfig.contentPosition.value)">
      <ng-container *ngIf="data == 'signatureImage' || data == 'isDraw'; else displayColon"></ng-container>
    <ng-template #displayColon>
      <div style="word-break: break-word;" [style.textAlign]="signConfig.contentPosition.value">
        {{signConfig[data].label | translate}}: {{signConfig[data].value}}
      </div>
    </ng-template>

    <!--        <div [style.font-style]="signConfigClone.fontStyle.value || ''" [style.font-weight]="signConfigClone.fontWeight.value || ''" [style.fontFamily]="signConfigClone.fontFamily.value || 'Times-Roman'" class="label"></div>&nbsp;-->

    <!--      <div [style.font-style]="signConfigClone.fontStyle.value || ''" [style.font-weight]="signConfigClone.fontWeight.value || ''" [style.fontFamily]="signConfigClone.fontFamily.value || 'Times-Roman'" align="start" style="word-break: break-word; white-space: pre-wrap;">-->
    <!--        <ng-container>-->
    <!--          {{signConfigClone[data].value}}-->
    <!--        </ng-container>-->
    <!--      </div>-->
  </div>
</ng-template>